export default "__VITE_ASSET__CoEKubvN__"